<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-row>
        <v-col><h2>Teachers</h2></v-col>
        <v-col class="text-right">
          <v-btn
            :disabled="!isAdmin"
            rounded
            outlined
            class="mb-1"
            :to="{
              name: 'PageEducatorInstitutionTeacherChangeAdmin',
              params: { id: this.$route.params.id },
            }"
            color="primary"
          >
            Change admin
          </v-btn>
          <v-btn
            rounded
            :to="{
              name: 'PageEducatorInstitutionTeacherAdd',
              params: { id: this.$route.params.id },
            }"
            class="ml-2 mb-1"
            color="primary"
          >
            + New Teacher
          </v-btn>
        </v-col>
      </v-row>
      <v-card-title></v-card-title>
      <ListAll
        :url="url"
        :headers="headers"
        :callbackClick="clickRead"
      ></ListAll>
    </v-card>
  </v-container>
</template>
    
    <script>
import { mapState } from "vuex";
import ListAll from "../../components/Datatable/ListAll.vue";
export default {
  components: {
    ListAll,
    //
  },
  computed: {
    size() {
      const size = { xs: "small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  // computed: mapState({
  //     auth: (state) => state.auth.data,
  //   }),
  props: [
    //
  ],
  data: () => ({
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    isAdmin: false,
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC

    headers: [
      {
        text: "#",
        align: "start",
        sortable: false,
        value: "index",
      },
      { text: "Name", value: "userName" },
      { text: "Mobile", value: "userAccountMobile" },
      { text: "Position", value: "positionName" },
      { text: "Joined", value: "joinedStatus" },
      { text: "", value: "button", align: "end" },
    ],
  }),
  created() {
    this.breadcrumbs = [
      {
        text: "Dashboard",
        to: { name: "PageEducatorDashboard" },
        exact: true,
      },
      {
        text: "My Institution",
        to: {
          name: "PageEducatorInstitutionDashboard",
          params: { id: this.$route.params.id },
        },
        exact: true,
      },
      {
        text: "Teachers",
        to: {
          name: "PageEducatorInstitutionTeacher",
          params: { id: this.$route.params.id },
        },
        exact: true,
      },
    ]
    //
    this.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
      "/educator/institution/" +
      this.$route.params.id +
      "/teacher";

    this.api.method = "GET";
    this.api.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
      "/educator/institution/" +
      this.$route.params.id;

    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
    };

    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };

    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      if (resp.accountId == this.auth.Account.id) {
        this.isAdmin = true;
      }
      // this.updateBreadcrumb(resp);
      return resp;
    };
  },
  mounted() {
    this.$api.fetch(this.api);
  },
  methods: {
    // updateBreadcrumb(resp) {
    //   this.breadcrumbs.push({
    //     text: "Dashboard",
    //     to: { name: "PageEducatorDashboard" },
    //     exact: true,
    //   });
    //   this.breadcrumbs.push({
    //     text: resp.name,
    //     to: {
    //       name: "PageEducatorInstitutionDashboard",
    //       params: { id: this.$route.params.id },
    //     },
    //     exact: true,
    //   });

    //   this.breadcrumbs.push({
    //     text: "Teachers",
    //     to: { name: "PageEducatorInstitutionTeacher" },
    //     exact: true,
    //   });
    // },
    clickRead(item) {
      this.$router.push({
        name: "PageEducatorInstitutionTeacherRead",
        params: { parentId: this.$route.params.id, id: item.id },
      });
    },
  },
};
</script>
<style scoped>
.menu-item {
  border: 1px solid black;
  margin: 3px;
}
.form-content {
  width: 600px !important;
}
</style>